import React from 'react';

export interface AEMHtmlProps {
  readonly contents: string | undefined;
}

/** AEMHtml component takes any string (contents) and injects it as-is into an HTML element */
const AEMHtml: React.FunctionComponent<AEMHtmlProps> = ({contents}) =>
  contents ? <div dangerouslySetInnerHTML={{__html: contents}} /> : null;

export default AEMHtml;
